module.exports = __webpack_public_path__ + "img/pleisure_bodyimage03-2.f91989ee.jpg";